import { render, staticRenderFns } from "./forward_log.vue?vue&type=template&id=3a3b6ba3&scoped=true&"
import script from "./forward_log.vue?vue&type=script&lang=js&"
export * from "./forward_log.vue?vue&type=script&lang=js&"
import style0 from "./forward_log.vue?vue&type=style&index=0&id=3a3b6ba3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3b6ba3",
  null
  
)

export default component.exports